import type { GroupBy } from '../lib/filters/types';

const OPTIONS: { id: GroupBy; label: string }[] = [
  { id: 'decision', label: 'Decision' },
  { id: 'lifecycle', label: 'Lifecycle' },
  { id: 'priorityBand', label: 'Priority Band' },
  { id: 'category', label: 'Category' },
];

export function GroupingToggle({ value, onChange }: { value: GroupBy; onChange: (v: GroupBy) => void }) {
  return (
    <div className="inline-flex rounded border border-slate-300 bg-white text-xs">
      {OPTIONS.map((o) => (
        <button
          key={o.id}
          type="button"
          onClick={() => onChange(o.id)}
          className={`px-3 py-1 ${value === o.id ? 'bg-brand text-white' : 'text-slate-700 hover:bg-slate-50'}`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
